<template>
    <div v-if="$store.state.openid != ''">
        <top-bar>
            <div class="title">
                  投诉举报
            </div>
        </top-bar>
        <van-form @submit="onSubmit">
            <van-field
                @blur="checkPhone"
                v-model="phone"
                name="phone"
                label="联系方式"
                placeholder="填写联系方式"
                maxlength="11"
                :rules="[{ required: true, message: '填写联系方式' }]"
            />
            <van-field
                v-model="remark"
                type="textarea"
                autosize
                show-word-limit
                row="8"
                maxlength="500"
                name="problem"
                label="投诉内容"
                placeholder="填写投诉内容"
                :rules="[{ required: true, message: '投诉内容' }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
            <van-dialog v-model="show" title="提示" @confirm="confirm">
                <div class="cont">点击进行实名验证</div>
            </van-dialog>
        </van-form>
    </div>
</template>

<script>
import Vue from "vue";
import TopBar from "@/components/Top";
import { Form,Field,Button,Toast } from "vant";
import { isPhone } from '@/common/common'
import { httpAction,getOpenId } from '@/http/salary'
import { init,GetQueryString } from '@/utils/getOpenId'

Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);

export default {
    data() {
        return {
            phone: "",
            remark: "",
            show: false,
        };
    },
    components:{ TopBar },
    created() {
        this.$cookies.set('history','complaint',60 * 60 * 1)
        if(this.$store.state.openid == ''){
            let openid = this.$route.query.openId
            this.$store.dispatch('SAVEUSERACTION',openid)
        }


        // if(this.$store.state.openid == ''){
        //     this.$cookies.set('history','complaint',60 * 60 * 1)
        //     let url = encodeURI('http://testwx-platform.engma.net/#/complaint')
        //     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=${url}&state=complaint#wechat_redirect`
        // }else{
        //     this.openid =  this.init()
        // }
    },
    methods: {
        async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                return res.data
            }
        },
        onSubmit(values) {
            httpAction('post','/weixin/complain/add',values).then((res) => {
                if(res.success){
                    Toast.success('提交成功')
                    this.phone = ''
                    this.remark = ''
                }else  if(res.msg == '您还没有实名认证'){
                    this.show = true
                }
            })
        },
        checkPhone(){
            if(this.phone){
                if(!isPhone(this.phone)){
                    Toast.fail('手机号错误')
                    this.phone = ''
                }
            }
        },
        confirm(){
            this.$cookies.set('history','complaint',60 * 60 * 1)
            this.$router.push('./Certification')
        }
    },
};
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 100%;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
}
.cont{
    text-align: center;
    padding: 20px;
}
</style>